import { render, staticRenderFns } from "./PageInNavigation.vue?vue&type=template&id=e1247b14&scoped=true&"
import script from "./PageInNavigation.vue?vue&type=script&lang=js&"
export * from "./PageInNavigation.vue?vue&type=script&lang=js&"
import style0 from "./PageInNavigation.vue?vue&type=style&index=0&id=e1247b14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1247b14",
  null
  
)

export default component.exports